module.exports = __webpack_public_path__ + "img/head-mv07.1d1ed48a.jpg";